import Cell from './cell';
import { defineVxeComponent } from '../../ui/src/comp';
import { assembleColumn, destroyColumn } from './util';
import { columnProps, columnWatch } from './column';
export default {
    name: 'VxeColgroup',
    props: columnProps,
    provide() {
        return {
            $xecolumn: this,
            $xegrid: null
        };
    },
    inject: {
        $xetable: {
            default: null
        },
        $xecolumn: {
            default: null
        }
    },
    watch: columnWatch,
    created() {
        this.columnConfig = this.createColumn(this.$xetable, this);
    },
    mounted() {
        const { $scopedSlots } = this;
        const columnSlots = {};
        if ($scopedSlots.header) {
            columnSlots.header = $scopedSlots.header;
        }
        this.columnConfig.slots = columnSlots;
        assembleColumn(this);
    },
    destroyed() {
        destroyColumn(this);
    },
    render(h) {
        return h('div', this.$slots.default);
    },
    methods: Cell
};
